import {Checkliste} from '../types/checkliste';
import {SyncedRemoteCollectionStore} from '@softline/core'

export const ChecklistenStore = SyncedRemoteCollectionStore.create<Checkliste>();
